<template>
  <comments-component
    :object="object"
    @onCommentsChanged="onCommentsChanged"
    :canAddComment="canAddComment"
    :closeCommentForm="closeCommentForm"
  />
</template>
<script>
import { Button } from "element-ui";
import CommentsComponent from "@/components/Comments/CommentsComponent.vue";

export default {
  name: "property-comments",

  components: {
    CommentsComponent,
    [Button.name]: Button,
  },

  props: {
    object: {
      type: Object,
      required: true,
      description: "Comments linked object",
    },
    canAddComment: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      closeCommentForm: false
    };
  },
  created() {},

  methods: {
    onCommentsChanged() {
      this.closeCommentForm = true;
      this.$emit("onCommentsChanged", true);
    },
  },

  watch: {
  },
};
</script>

<style lang="scss" scoped></style>